/* eslint-disable @typescript-eslint/no-unused-expressions */
import { energyApi } from "utilities/Axios";
// import { energyApi, authApi } from "utilities/Axios";

export const getAllUsersForAdmin = () => {
  return energyApi.get("/api/Auth/users");
};

export const UpdateUserRole = (data: any) => {
  // return authApi.post("/api/user/assignrole", data,);
};

export const getRoles = () => {
  // return authApi.get("/api/user/UserRoles");
};

export const updateUserRole = (data: any) => {
  // return authApi.post("/api/user/assignrole", data,);
};

export const getAllUsers = () => {
  return energyApi.get("/api/Auth/users");
};

export const deleteUser = (data: any) => {
  // return energyApi.get("/user/deleteuser" + `?id=${data}`);
};
